<template lang="pug">
  v-container.pa-5
    div.h5.primary--text What do you need to know about your customers?
    div.p2.basic700--text.mt-4 Guests will need to provide these information before proceeding with their purchase.
    
    v-card.my-6(outlined)
      v-simple-table(fixed-header)
        template(v-slot:default)
          thead
            tr
              th.text-left.basic200.primary400--text.pr-1.pl-3 {{ $t('customer_info') }}
              th.text-center.basic200.primary400--text.px-1 {{ $t('include') }}
              th.text-center.basic200.primary400--text.px-1 {{ $t('required') }}
              th.text-center.basic200.primary400--text.px-3(v-if="form.extra_fields && form.extra_fields.length > 0") {{ $t('actions') }}
          tbody
            tr
              td.py-2.pr-1.pl-3
                div.p2.primary--text {{ selectedLang.nameLabel }}
              td.px-1(align="center")
                v-row(no-gutters justify="center")
                  v-col.shrink
                    y-checkbox.mb-n2(v-model="dummy.name" hide-details readonly disabled)
              td.px-1
                v-row(no-gutters justify="center")
                  v-col.shrink
                    y-checkbox.mb-n2(v-model="dummy.name" hide-details readonly disabled)
              td.pl-1(v-if="form.extra_fields && form.extra_fields.length > 0")

            tr
              td.py-2.pr-1.pl-3
                div.p2.primary--text {{ selectedLang.phoneLabel }}
              td.px-1
                v-row(no-gutters justify="center")
                  v-col.shrink
                    y-checkbox.mb-n2(v-model="dummy.phone" hide-details readonly disabled)
              td.px-1
                v-row(no-gutters justify="center")
                  v-col.shrink
                    y-checkbox.mb-n2(v-model="dummy.phone" hide-details readonly disabled)
              td.pl-1(v-if="form.extra_fields && form.extra_fields.length > 0")

            tr
              td.py-2.pr-1.pl-3
                div.p2.primary--text {{ selectedLang.emailLabel }}
              td.px-1
                v-row(no-gutters justify="center")
                  v-col.shrink
                    y-checkbox.mb-n2(v-model="form.email_enabled" hide-details)
              td.px-1
                v-row(no-gutters justify="center")
                  v-col.shrink
                    y-checkbox.mb-n2(v-model="form.email_required" hide-details :disabled="!form.email_enabled")
              td.pl-1(v-if="form.extra_fields && form.extra_fields.length > 0")

          draggable.extra-fields(v-model="form.extra_fields" handle=".handle" tag="tbody" @start="drag=true"  @end="drag=false")
            template(v-for="(extraField, fieldIndex) in form.extra_fields")
              extra-form-field(:key="extraField.name + fieldIndex" :field.sync="extraField" :index="fieldIndex" @deleted="handleDeleteItem" @edited="handleFieldEdited")

          tbody
            tr
              td(:colspan="(form.extra_fields && form.extra_fields.length > 0) ? '4' : '3'" style="height: 40px;border-top: thin solid rgba(0, 0, 0, 0.12);")
                div(align="center")
                  v-btn.button-Aa-small.custom-transform-class.text-none(color="textColorAccent" text @click="showAddExtraDialog = true" small)
                    v-icon.mr-2(color="textColorAccent" size="17") mdi-plus
                    | {{ $t('collect_extra_info') }}
                        
    div.d-flex.align-center.mt-3
      div.mr-2.p2.primary500--text {{ $t('use_sales_page') }}
      v-menu(left :offset-y='true')
        template(v-slot:activator='{ on }')
          v-chip.px-3(color="basic300" small label v-on="on")
            div.button-AA-tiny.primary--text.text-uppercase {{ getFormLanguageDisplay() }}
            v-icon.ml-1(right small) mdi-chevron-down
        v-list
          v-list-item.my-n2(v-for="(language, index) in languages" :key="language.id" @click="form.language = language.id")
            v-list-item-title.p2 {{ language.name }}

    .modals
      add-wa-extra-field(v-if="showAddExtraDialog" :open.sync="showAddExtraDialog" @added="handleFieldAdded")
</template>

<script>
import AddWaExtraField from '@/components/dialogs/AddWaExtraField.vue'
import ExtraFormField from '@/components/ExtraFormField.vue'
import draggable from 'vuedraggable'

export default {
  name: 'LandingExtraField',
  props: ['parentForm'],
  components: { AddWaExtraField, ExtraFormField, draggable },
  data: () => ({
    dummy: {
      name: true,
      phone: true
    },
    customerEmail: true,
    showAddExtraDialog: false,
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)',
      padding: '16px'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '17px'
    },
    languages: [
      { name: 'English', id: 'en' },
      { name: 'Bahasa Malaysia', id: 'ms' },
      { name: 'Bahasa Indonesia', id: 'id' },
      { name: 'Chinese', id: 'zh' },
      { name: 'Tamil', id: 'ta' }
    ],
    langLabel: [
      {
        id: 'en',
        nameLabel: 'Name',
        phoneLabel: 'Phone',
        emailLabel: 'Email'
      },
      {
        id: 'ms',
        nameLabel: 'Nama',
        phoneLabel: 'No Telefon',
        emailLabel: 'E-mel'
      },
      {
        id: 'id',
        nameLabel: 'Nama',
        phoneLabel: 'Nomor Telepon',
        emailLabel: 'Email'
      },
      {
        id: 'zh',
        nameLabel: '姓名',
        phoneLabel: '电话号码',
        emailLabel: '电子邮件'
      },
      {
        id: 'ta',
        nameLabel: 'பெயர்',
        phoneLabel: 'தொலை பேசி இலக்கம்',
        emailLabel: 'மின் அஞ்சல்'
      }
    ],
  }),
  computed: {
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
    selectedLang () {
      return this.langLabel.find(f => f.id === this.form.language)
    }
  },
  methods: {
    handleDeleteItem (index) {
      this.form.extra_fields.splice(index, 1)
    },
    handleFieldAdded (field) {
      if (!this.form.extra_fields) {
        this.form.extra_fields = []
      }
      this.form.extra_fields.push(field)
    },
    handleFieldEdited (field, index) {
      this.form.extra_fields[index] = field
    },
    getFormLanguageDisplay () {
      const selectedLanguage = this.languages.filter((obj) => {
        return obj.id == this.form.language
      })
      if (selectedLanguage.length > 0) {
        return selectedLanguage[0].name
      }
      return this.form.language
    },
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "customer_info": "Customer Info",
    "include": "Include",
    "required": "Required",
    "actions": "Actions",
    "collect_extra_info": "Collect Extra Info",
    "customer_explain": "Check or add any extra information that should appear on your customer form.",
    "use_sales_page": "Use Sales Page in"
  },
  "id": {
    "customer_info": "Informasi Pelanggan",
    "include": "Termasuk",
    "required": "Diperlukan",
    "actions": "Tindakan",
    "collect_extra_info": "Kumpulkan Info Ekstra",
    "customer_explain": "Cek atau tambah informasi lainnya yang perlu tampil dalam form pelanggan.",
    "use_sales_page": "Guna Sales Page pada"
  }
}
</i18n>